import { filterPointsByWeek } from "./common.js";
import { calculateAchievementPoints } from "./achievements.js";

/**
 * Merges user data from entries into the group's members list.
 * @param {Array} groups - Array of group objects.
 * @param {Array} entries - Array of user entry objects.
 * @returns {Array} Updated array of groups with enriched member data.
 */
function mapGroupsWithEntries(groups, entries) {
  // First pass: map each group to its color and merge member data
  let mappedGroups = groups.map((group) => ({
    ...group,
    members: group.members.map((member) =>
      mergeMemberWithEntry(member, entries)
    )
  }));

  // Second pass: calculate points for each group
  mappedGroups = mappedGroups.map((group) => {
    let pointsAllTime = group.members.reduce(
      (sum, member) => sum + member.pointsAllTime,
      0
    );
    let pointsWeekly = group.members.reduce(
      (sum, member) => sum + member.pointsWeekly,
      0
    );

    return {
      ...group,
      pointsAllTime: pointsAllTime,
      pointsWeekly: pointsWeekly
    };
  });

  return mappedGroups;
}

/**
 * Finds and merges matching entry data into a member object.
 * @param {Object} member - Group member object (must have `id`).
 * @param {Array} entries - Array of user entry objects.
 * @returns {Object} Updated member object with merged entry data if found.
 */
function mergeMemberWithEntry(member, entries) {
  const matchedEntry = entries.find(
    (entry) => entry.userId === String(member.id)
  );

  let pointsAllTime = 0;
  let pointsWeekly = 0;

  if (matchedEntry) {
    pointsAllTime = calculateAchievementPoints(matchedEntry.codes);
    pointsWeekly = calculateAchievementPoints(filterPointsByWeek(matchedEntry));
  }

  return {
    ...member,
    ...(matchedEntry || {}),
    pointsAllTime,
    pointsWeekly
  };
}

export { mapGroupsWithEntries };
